export default "__VITE_ASSET__B628e43A__"